import moment from 'moment';
import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { AfTranslateFactory } from '@shared/modules/translate/factory/translate.factory';
import { DateConverterService } from '@shared/services/date-converter/date-converter.service';
import { PickerDataSimpleComponent } from '../picker-data-simple/picker-data-simple.component';
import { FormsModule } from '@angular/forms';
import { NgClass } from '@angular/common';
import { FieldTypeDateComponent } from '../field-type-date/field-type-date.component';
import { AfTranslateDirective } from '../../modules/translate/directive/af-translate.directive';
import { ModalServiceService } from '@shared/services/modal-service/modal-service.service';

@Component({
  selector: 'expiration-period',
  templateUrl: './expiration-period.component.html',
  standalone: true,
  imports: [AfTranslateDirective,
    FieldTypeDateComponent,
    NgClass,
    FormsModule,
    PickerDataSimpleComponent
  ]
})
export class ExpirationPeriodComponent implements OnInit {
  concept:any = this.dialogConfig.data.concept;
  expirationPeriod: any = {
    intervalRepeat: {
      startInterval: null,
      selectInterval: 'no-end-date',
      finishIntervalDate: null,
      date:null,
    },
    repeatIntervalDate:{
      id: "repeat-inteval-date",
      noEditable: true,
      label: this.translate.instant('expiration-period.init-survey')
    }
  }

  constructor(
    private dateConverterService: DateConverterService,
    private translate: AfTranslateFactory,
    private modalService: ModalServiceService,
    private dialogRef: DynamicDialogRef<ExpirationPeriodComponent>,
    private dialogConfig: DynamicDialogConfig) { }

  ngOnInit(): void {
    let that: any = this.expirationPeriod;
    if(this.concept?.pollBeginDate){
      that.intervalRepeat.startInterval = this.dateConverterService.toDate(this.concept.pollBeginDate);
    }
    if(this.concept?.pollExpirationDate){
      that.intervalRepeat.finishIntervalDate = this.dateConverterService.toDate(this.concept.pollExpirationDate);
      that.intervalRepeat.selectInterval ='end-interval-day';
    }
  }

  selectOption(type:string, e:any){
    this.expirationPeriod[type] = e.newValue;
  }

  selectIntervalDate(e:any, type:string){
    this.expirationPeriod.intervalRepeat[type] = e.date;
    this.expirationPeriod.hasError = false;
    this.expirationPeriod.textError = '';
  }

  validateRepetition(){
    let that: any = this.expirationPeriod;
    that.hasError = false;
    that.textError ='';
    let initInterval: any = that.intervalRepeat.startInterval?that.intervalRepeat.startInterval : new Date();
    if(moment(initInterval).valueOf() > moment(that.intervalRepeat.finishIntervalDate).valueOf()){
      that.hasError = true;
      that.textError = this.translate.instant('expiration-period.expiration-error');
    }else if(that.intervalRepeat.selectInterval === 'end-interval-day' && !that.intervalRepeat.finishIntervalDate){
      that.hasError = true;
      that.textError = this.translate.instant('expiration-period.error-null-date');
    }
    if(that.hasError){
      this.modalService.errorModal({ text: this.translate.instant('expiration-period.check-error-modal')});
    }else{
      this.handleAccept();
    }
  }

  extractDate(){
    let that: any = this.expirationPeriod;
    if(that.intervalRepeat.startInterval){
      that.intervalRepeat.startInterval = this.dateConverterService.toIso(that.intervalRepeat.startInterval);
    }
    if(that.intervalRepeat.selectInterval === 'end-interval-day'){
      that.intervalRepeat.date = this.dateConverterService.toIso(that.intervalRepeat.finishIntervalDate);
      that.intervalRepeat.finishIntervalDate = this.dateConverterService.toIso(that.intervalRepeat.finishIntervalDate);
    }
    return that.intervalRepeat;
  }

  closeAdvice(type:any){
    this.expirationPeriod[type] = false;
  }

  handleAccept() {
    this.dialogRef.close({
      result: 'ok',
      interval: this.extractDate()
    })
  }

  handleDismiss() {
    this.dialogRef.close({result:'cancel'});
  }


}
